import * as React from "react";
import * as $ from "jquery";
import update = require("react-addons-update");

export enum ProgressStatus
{
	Indeternminate,
	InProgress,
	Success,
	Failure
}

export interface ButtonProps
{
	label: string;
	icon?: string;
	tooltip?: string;
	isAjax?: boolean;
	isDisabled?: boolean;
	className?: string;
	inlineStyle?: any;
	progressLabel?: string;
	progressDoneLabel?: string;
	progressClass?: string;
	successClass?: string;
	errorClass?: string;
	disabledLabel?: string;
	clickThrottle?: number;
	clickThrottleMessage?: string;
	onClick?: (event: React.MouseEvent<any>) => void | JQueryPromise<any>;
}

export interface ButtonState
{
	label: string;
	previousLabel?: string;
	isDisabled?: boolean;
	clickCount?: number;
	lastClick?: Date;
	cssClass?: string;
	progress?: number;
	status?: ProgressStatus;
}

export class Button extends React.Component<ButtonProps, ButtonState>
{
	static defaultProps: ButtonProps = {
		label: "Ok",
		progressLabel: "Processing...",
		progressDoneLabel: "Done!",
		clickThrottle: 5000,
		clickThrottleMessage: "We get it, it's taking too long. It will be done soon.",
		successClass: "btn-success",
		errorClass: "btn-danger",
		progressClass: "btn-progress"
	};
	private progressbar: HTMLSpanElement;

	constructor(props: ButtonProps)
	{
		super(props);
		this.state = { label: props.label, clickCount: 0, status: ProgressStatus.Indeternminate };
	}

	componentDidMount()
	{

		this.setState(update(this.state, { $set: { "label": this.props.label } }));
	}

	componentWillReceiveProps(nextProps: ButtonProps)
	{
		this.setState(update(this.state, { $set: { "label": nextProps.label } }));
	}

	componentWillUnmount()
	{}

	private onClick(event: React.MouseEvent<any>)
	{
		this.throttleClick();
		if (this.state.isDisabled)
		{
			return;
		}
		if (this.props.onClick)
		{
			const hasPromise = this.props.onClick(event) as JQueryPromise<any>;
			if (hasPromise)
			{
				this.processingAjax();
				hasPromise
					.done(() =>
					{
						this.processingAjaxDone();
					})
					.fail(() =>
					{
						this.processingAjaxFail();
					});
			}
		}
	}

	private throttleClick()
	{
		if (!this.state.isDisabled)
		{
			return;
		}

		let current = this.state;
		const isAlreadyShowingThrottleMessage = current.label === this.props.clickThrottleMessage;
		const newState: any = {
			"previousLabel": isAlreadyShowingThrottleMessage ? current.previousLabel : current.label,
			"lastClick": new Date(),
			"clickCount": current.clickCount + 1
		};
		if (current.lastClick)
		{
			const timeBetweenClicks = newState.lastClick.getTime() - current.lastClick.getTime();
			const isClickTooFast = this.props.clickThrottle > timeBetweenClicks;
			if (isClickTooFast)
			{
				newState["label"] = this.props.clickThrottleMessage;
			}
		}

		const updated = update(current, { $set: newState });
		this.setState(updated);
		if (!isAlreadyShowingThrottleMessage)
		{
			setTimeout(() =>
				{
					this.setState(update(this.state, { $set: { label: this.state.previousLabel } }));
				},
				3000);
		}
	}

	private processingAjax()
	{
		const state = update(this.state, { $set: { isDisabled: true, label: this.props.progressLabel, progress: 1 } });
		this.setState(state);
	}

	private processingAjaxDone()
	{
		const state = update(this.state,
			{ $set: { isDisabled: false, label: this.props.progressDoneLabel, progress: 100, status: ProgressStatus.Success } });
		this.setState(state);
		setTimeout(() =>
			{
				this.setState(update(this.state, { $set: { label: this.props.label, status: ProgressStatus.Indeternminate } }));
				this.setProgress(0);
			},
			1000);
	}

	private processingAjaxFail()
	{
		const state = update(this.state,
			{ $set: { isDisabled: false, label: this.props.label, progress: 100, status: ProgressStatus.Failure } });
		this.setState(state);
		setTimeout(() =>
			{
				this.setProgress(0);
			},
			1000);
	}

	private setProgress(progress: number)
	{
		const state = update(this.state, { $set: { progress: progress } });
		this.setState(state);
	}

	render()
	{
		const icon = this.createIcon();
		const showProgressBar = this.state.progress ? "loading" : "";
		const status = this.getStatus();
		return <button type="button" className={`progress-btn btn ${this.props.className || ""} ${showProgressBar || ""} ${
			status || ""} ${this.state.cssClass || ""}`} style={this.props.inlineStyle} title={this.props
				.tooltip} data-horizontal data-style="slide-down" onClick={this.onClick.bind(this) }>
			       <span className="content">
				       {icon}
				       <span>{this.state.label}</span>
			       </span>
			       <span className="progress">
				       <span className="progress-inner" ref={(r: any) => this
					       .progressbar = r} style={{ width: this.state.progress + "%" }}></span>
			       </span>
		       </button>;
	}

	private createIcon()
	{
		const icon = this.props.icon;
		if (icon)
		{
			return <i className={`fa fa-fw ${icon}`}></i>;
		}
		return null;
	}

	private getStatus()
	{
		const status = this.state.status;
		switch (status)
		{
			case ProgressStatus.Failure:
				return "error";
			case ProgressStatus.Success:
				return "success";
		}
		return "";
	}
}


// WEBPACK FOOTER //
// ./src/components/common/Button.tsx